<script setup>

</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.33359 13.5C3.33359 13.7761 3.55745 14 3.83359 14H10.9349C11.7103 14 12.0003 13.7565 12.0003 12.9333V11.9699M3.33359 13.5C3.33359 12.6716 4.00516 12 4.83359 12H11.6016C11.7524 12 11.8848 11.9908 12.0003 11.9699M3.33359 13.5V4.13346C3.33359 3.37606 3.28559 2.54065 4.06145 2.14532C4.34667 2 4.72032 2 5.46705 2H11.6004C12.4239 2 12.6669 2.29105 12.6669 3.06673V10.9334C12.6669 11.5965 12.4788 11.8834 12.0003 11.9699" stroke="#020618" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style scoped>

</style>
